<lm-lpl-editor #LplEditor
   [lpl]="uiFieldSpec.lpl"
   [readonly]="true"
></lm-lpl-editor>